import { useCallback } from "react";
import { useSelector } from "react-redux";
import {
  companySettingsSelector,
  formatSettingsSelector,
  instrumentsSettingsSelector,
  peersSettingsSelector,
  templateSettingsSelector,
  defaultTabSettingsSelector,
  currencyEnabledSettingsSelector,
  currenciesSelector,
  currenciesSettingIndexerSelector,
} from "../store/slice/settings/selectors";

/**
 *
 * @returns {import("../..").CompanySetting}}
 */
export const useCompanySettings = () => {
  return useSelector(companySettingsSelector);
};

export const useInstrumentsSetting = () => useSelector(instrumentsSettingsSelector);

export const usePeersSetting = () => useSelector(peersSettingsSelector);
/**
 *
 * @returns {import("../..").IFormatSetting}}
 */
export const useFormatSetting = () => useSelector(formatSettingsSelector);

export function useTemplateSetting() {
  return useSelector(templateSettingsSelector);
}

export function useDefaultTab() {
  return useSelector(defaultTabSettingsSelector);
}

export function useCurrencyEnabled() {
  return useSelector(currencyEnabledSettingsSelector);
}

export function useCurrencies() {
  return useSelector(currenciesSelector);
}

export function useCurrencyLabel() {
  const indexer = useSelector(currenciesSettingIndexerSelector)

  return useCallback((currencyCode) => {
    const result = indexer[currencyCode];

    if(!result) return currencyCode

    return result;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
